import QRCodeReaderDialog from './QRCodeReaderDialog';
export default QRCodeReaderDialog;